import { useIcons } from "../egencia-provider/index.js";
import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkIconSpotlights, UitkIconThemes } from "./types.js";
export var UitkIconSize = /* @__PURE__ */ ((UitkIconSize2) => {
  UitkIconSize2["XSMALL"] = "xsmall";
  UitkIconSize2["SMALL"] = "small";
  UitkIconSize2["MEDIUM"] = "medium";
  UitkIconSize2["LARGE"] = "large";
  UitkIconSize2["XLARGE"] = "xlarge";
  return UitkIconSize2;
})(UitkIconSize || {});
export function UitkIcon({
  className,
  description,
  id,
  name,
  size = "medium" /* MEDIUM */,
  theme,
  title,
  shadow,
  spotlight,
  style
}) {
  let svgIcon;
  const baseCssClass = "uitk-icon";
  const throwNameError = (nameError) => {
    console.error(`Invalid icon name prop: ${nameError}`);
  };
  if (!name) {
    throwNameError(name);
  }
  if ((title || description) && !id) {
    console.error(`Icon ${name} requires 'id' if 'title' or 'description' are provided`);
  }
  const getDropShadowValues = () => {
    const dropShadowValues = {
      dx: 0,
      dy: 0,
      stdDeviation: 1
    };
    return dropShadowValues;
  };
  const uid = Math.random().toString(36).substring(7);
  const filterId = `shadow-filter${id ? `-${id}` : `-${uid}`}`;
  const domRef = (b) => {
    svgIcon = b;
  };
  const isDirectional = name && /_(?:back|forward|left|right|before|next|half)$/.test(name);
  const wrapperClassNames = classNames(
    baseCssClass,
    className,
    {
      [`${baseCssClass}-directional`]: isDirectional
    },
    spotlight && `${baseCssClass}-spotlight-icon`,
    size && `${baseCssClass}-${size}`,
    theme && UitkIconThemes.get(theme)
  );
  const spotlightIconContainerClassNames = classNames(
    spotlight && size === "small" /* SMALL */ ? `${baseCssClass}-spotlight-small ${baseCssClass}-spotlight` : `${baseCssClass}-spotlight`,
    spotlight && `${baseCssClass}-${UitkIconSpotlights.get(spotlight)}`,
    spotlight && theme && `${baseCssClass}-${UitkIconSpotlights.get(spotlight)}-${theme}`
  );
  const isSVGFEDropShadowElement = typeof SVGFEDropShadowElement === "function";
  const egdsIconStyle = shadow && isSVGFEDropShadowElement ? { filter: `url(#${filterId})` } : void 0;
  const outerSvgProps = {
    "aria-describedby": description ? `${id}-description` : void 0,
    "aria-hidden": title || description ? void 0 : true,
    "aria-labelledby": title ? `${id}-title` : void 0,
    role: title || description ? "img" : void 0,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  };
  const { getIcon } = useIcons();
  const svgToRender = (svgName) => {
    const EgdsIcon = getIcon(svgName);
    if (!EgdsIcon) {
      throwNameError(name);
      return false;
    }
    return /* @__PURE__ */ React.createElement(EgdsIcon, { style: egdsIconStyle });
  };
  const iconMarkup = /* @__PURE__ */ React.createElement("svg", { ref: domRef, className: wrapperClassNames, style, ...outerSvgProps }, title && /* @__PURE__ */ React.createElement("title", { id: `${id}-title` }, title), description && /* @__PURE__ */ React.createElement("desc", { id: `${id}-description` }, description), shadow && /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", { id: filterId }, /* @__PURE__ */ React.createElement("feDropShadow", { ...getDropShadowValues() }))), svgToRender(name));
  const spotlightIconMarkup = /* @__PURE__ */ React.createElement("div", { className: spotlightIconContainerClassNames }, iconMarkup);
  return spotlight ? spotlightIconMarkup : iconMarkup;
}
;
export const getMetaData = (metaDataProps) => {
  if (!metaDataProps) {
    console.error("Must pass something");
    return false;
  }
  if (!metaDataProps.data) {
    console.error("Must pass name or data property");
    return false;
  }
  const icon = metaDataProps;
  const iconData = icon.data;
  const iconProps = { ...metaDataProps };
  const svgProps = {
    role: "icon",
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg",
    ...icon.attrs
  };
  Object.assign(svgProps, {
    "aria-hidden": true
  });
  return {
    iconData,
    iconProps,
    svgProps
  };
};
export const attributize = (obj) => Object.keys(obj).reduce((str, attr) => str += `${attr}="${obj[attr]}" `, "").trim();
export const getMarkerPopup = (markerProps) => {
  const { svgProps, iconData } = getMetaData(markerProps);
  return `<svg ${attributize(svgProps)}>${iconData}</svg>`;
};
UitkIcon.displayName = "UitkIcon";
